import React from "react";
import { toast } from "react-toastify";
import "./mapToast.css";

export const showMapConfirmToast = ({
    title = "Potvrda",
    message,
    confirmText = "Da",
    cancelText = "Ne",
    variant = "info",
    autoClose = 5000,
    showTimer = false,
    onConfirm,
}) => {
    toast(
        ({ closeToast }) => (
            <div className="map-toast-content">
                <div className="map-toast-title">{title}</div>

                <div className="map-toast-message">{message}</div>

                {(confirmText || cancelText) && (
                    <div className="map-toast-actions">
                        {confirmText && (
                            <button
                                type="button"
                                className={`map-toast-btn confirm ${variant}`}
                                onClick={() => {
                                    closeToast();
                                    if (typeof onConfirm === "function") onConfirm();
                                }}
                            >
                                {confirmText}
                            </button>
                        )}

                        {cancelText && (
                            <button
                                type="button"
                                className="map-toast-btn cancel"
                                onClick={closeToast}
                            >
                                {cancelText}
                            </button>
                        )}
                    </div>
                )}

                {showTimer && autoClose !== false && (
                    <div className="map-toast-timer">
                        <div
                            className={`map-toast-timer-fill ${variant}`}
                            style={{ animationDuration: `${autoClose}ms` }}
                        />
                    </div>
                )}
            </div>
        ),
        {
            position: "bottom-right",
            autoClose,
            closeOnClick: false,
            closeButton: false,
            draggable: false,
            hideProgressBar: true,
            className: `map-toast-wrapper ${variant}`,
            bodyClassName: "map-toast-body",
        }
    );
};